import { Button, Card, Divider, Form, Input } from 'antd';
import React from 'react';
import { Helmet } from 'react-helmet';
import Password from '../common/password';
import { getUserData } from '../../helpers/functions';
import { useDispatch } from 'react-redux';

export default function ChangeExpertPassword({ setShowProfilePage }) {
  const [updatePasswordForm] = Form.useForm();
  const dispatch = useDispatch();

  const onFinish = values => {
    dispatch({
      type: 'CHANGE_PASSWORD_REQUEST',
      formData: {
        ...values,
        email: getUserData().email,
      },
    });
  };
  const onFinishFailed = () => {};
  return (
    <section className="profile d-flex-a-c">
      <Helmet title="Change Password" />
      <div className="site-card-border-less-wrapper card-wrapper">
        <Card bordered={false}>
          <p className="m-title f20 tl">Change Password</p>
          <Form
            layout="vertical"
            name="basic"
            form={updatePasswordForm}
            hideRequiredMark={true}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              label="Current password"
              name="old_password"
              rules={[
                {
                  required: true,
                  message: 'Please enter current password',
                },
              ]}
            >
              <Input.Password size="large" placeholder="••••••••••" />
            </Form.Item>

            <Password isExtra={true} />
            <Form.Item
              label="Confirm Password"
              name="password_confirmation"
              dependencies={['password']}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: 'Please confirm your password',
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error('The two passwords that you entered do not match!'),
                    );
                  },
                }),
              ]}
            >
              <Input.Password size="large" placeholder="••••••••••" />
            </Form.Item>
            <Divider className="mt40 mb40" />
            <Form.Item>
              <Button type="link" size={'large'} onClick={() => setShowProfilePage(true)}>
                Cancel
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                // onClick={handlePasswordUpdate}
                className="float-r"
                size="large"
              >
                Update Password
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </section>
  );
}
